import { Circle, Droplets, SunMedium, Utensils } from 'lucide-react';
import {
  sensoryPresets,
  sensoryTraits,
  type SensoryAnswers,
  type SensoryPreset,
} from './sensory-feedback-model';
const icons = { skincare: Droplets, sunscreen: SunMedium, edible: Utensils, other: Circle };
export function SensoryFeedback({
  preset,
  answers,
  disabled,
  onPreset,
  onAnswers,
}: {
  readonly preset: SensoryPreset;
  readonly answers: SensoryAnswers;
  readonly disabled: boolean;
  readonly onPreset: (preset: SensoryPreset) => void;
  readonly onAnswers: (answers: SensoryAnswers) => void;
}) {
  return (
    <fieldset className="sensory-feedback" disabled={disabled}>
      <legend>ความรู้สึกจากการลองใช้</legend>
      <p className="muted">
        เลือกประเภทที่ตรงกับตัวอย่าง คะแนน 1–5 คือความพึงพอใจของคุณ · เว้นไว้ได้หากยังไม่ได้ลอง
      </p>
      <div className="sensory-presets" aria-label="ประเภทตัวอย่าง">
        {sensoryPresets.map((item) => {
          const Icon = icons[item.id];
          return (
            <button
              type="button"
              key={item.id}
              aria-pressed={preset === item.id}
              onClick={() => onPreset(item.id)}
            >
              <Icon aria-hidden="true" />
              {item.label}
            </button>
          );
        })}
      </div>
      <p className="fineprint">
        ความคิดเห็นนี้ไม่ใช่ผลทดสอบประสิทธิภาพหรือความปลอดภัย และไม่เปลี่ยนเกณฑ์ที่ตกลงกัน
      </p>
      <div className="sensory-traits">
        {sensoryTraits(preset).map(({ id, label }) => (
          <div className="sensory-trait" key={id}>
            <label className="field">
              ความพึงพอใจด้าน{label}
              <select
                value={answers[id]?.score ?? ''}
                onChange={(event) =>
                  onAnswers({
                    ...answers,
                    [id]: { note: answers[id]?.note ?? '', score: event.target.value },
                  })
                }
              >
                <option value="">ยังไม่ให้คะแนน / ยังไม่ได้ลอง</option>
                <option value="1">1 — ไม่พอใจ</option>
                <option value="2">2 — ค่อนข้างไม่พอใจ</option>
                <option value="3">3 — ปานกลาง</option>
                <option value="4">4 — พอใจ</option>
                <option value="5">5 — พอใจมาก</option>
              </select>
            </label>
            <label className="field">
              ข้อสังเกต / สิ่งที่อยากปรับด้าน{label}
              <textarea
                rows={2}
                value={answers[id]?.note ?? ''}
                onChange={(event) =>
                  onAnswers({
                    ...answers,
                    [id]: { score: answers[id]?.score ?? '', note: event.target.value },
                  })
                }
              />
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  );
}
